import React, { useState, useEffect } from "react";
import Aux from "../../../hoc/Auxilliary";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Button, Grid, Box } from "@material-ui/core/";
import { useDispatch, useSelector } from "react-redux";
import FormStyle from "./prospective.module.css";
import FormBuilder from "../../FormBuilder";
import { checkCoupon } from "../../../reduxSlices/applicationSlice";

import FormHeader from "../../FormHeader";
import MessageIndicator from "../../SnackBar";
import localizedStrings from "../../../utils/localize";

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classHeaderFont: {
    fontSize: "1.1rem",
    fontWeight: 800,
    flex: 1,
  },
  classContentFont: {
    fontSize: "1rem",
    flex: 1,
  },
  formDesign: {
    width: "100%",
    padding: "5px 15px",
    fontSize: "17px",
    lineHeight: "1.4",
  },
});

var formJson = {};
const Page8 = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles(props);

  const couponsExist = useSelector(
    (state) => state.applicationData.couponsExist,
  );
  const couponsData = useSelector((state) => state.applicationData.couponsData);

  const data = props?.applicationJsonData || [];
  const [applicationFee, setApplicationFee] = useState(props.formData);
  const [event, setEvent] = useState({
    isEvent: false,
    message: "",
    showSnackbar: false,
  });

  useEffect(() => {
    const newApplicationFee = { ...applicationFee };
    newApplicationFee.usb_couponcode.display =
      data?.applicationOptions === "Coupon" ? "block" : "none";
    setApplicationFee(newApplicationFee);
  }, [data]);

  useEffect(() => {
    const couponCode = couponsData?.some(
      (element) => element.ses_code === data.usb_couponcode,
    );
    if (couponsExist !== null) {
      if (couponCode) {
        let event = {
          isEvent: false,
          message: `${localizedStrings.applicationpage.couponaccepted}`,
          showSnackbar: true,
        };
        setEvent(event);
      }
      if (couponCode === false) {
        let event = {
          isEvent: false,
          message: `${localizedStrings.applicationpage.notavalidcouponcode}`,
          showSnackbar: true,
        };
        setEvent(event);
      }
    }
  }, [couponsData, couponsExist]);

  const textFieldChangeHandlerForApplication = (event, key) => {
    const updatedData = {
      ...data,
      [event.target.name]: event.target.value,
    };
    props.setApplicationJsonData(updatedData);
  };

  const applyCoupon = () => {
    const couponCode = {
      usb_couponcode: data.usb_couponcode,
    };
    dispatch(checkCoupon(couponCode));
  };

  const handleRadioChange = (event, name, value) => {
    const updatedData = {
      ...props?.applicationJsonData,
      [name]: value,
    };
    props.setApplicationJsonData(updatedData);
  };

  const handleClose = () => {
    if (event.showSnackbar) {
      let eventCopy = { ...event };
      eventCopy.showSnackbar = false;
      setEvent(eventCopy);
    } else {
      let errorCopy = { ...error };
      errorCopy.showSnackbar = false;
      setError(errorCopy);
    }
  };

  return (
    <Aux>
      <MessageIndicator
        open={event.showSnackbar}
        message={event.message}
        handleClose={handleClose}
      />
      <Grid xs={12}>
        <Grid style={{ padding: "0 2.5rem" }}>
          <Typography component="div" className={FormStyle.formContainer}>
            <FormHeader name="Frais de traitement de dossier" />
            <div className={classes.formDesign}>
              Il faut payer les frais de traitement de dossier afin de soumettre
              la demande d’admission. Ces frais sont payables par carte Visa ou
              Mastercard (crédit ou débit).
              <br />   <br/>
              Les frais de traitement de dossier sont non remboursables. Ils
              sont utilisés pour l’ouverture du dossier, le traitement des
              documents soumis dans le cadre de la demande, la communication
              (par courriel, téléphone ou en personne) et l’évaluation du
              dossier une fois qu’il est complet.
              <br /> <br/>
              Le fait de payer ces frais ne garantit pas une réponse immédiate à
              ta demande ni une réponse favorable. Si ton dossier reste
              incomplet, nous ne pourrons malheureusement pas l’évaluer ni
              donner suite à ta demande.
              <br />
            </div>
            <Box component="div" style={{ marginLeft: "1rem" }}>
              <FormBuilder
                formDetails={props.formData}
                value={data}
                handleRadioChange={handleRadioChange}
                changed={textFieldChangeHandlerForApplication}
              />
              {data?.applicationOptions === "Coupon" && (
                <Grid
                  container
                  justifyContent="center"
                  spacing={2}
                  style={{ paddingLeft: "5rem" }}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={applyCoupon}
                    >
                      {localizedStrings.applicationpage.applycouponcode}
                    </Button>
                    <br />
                  </Grid>
                </Grid>
              )}
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default Page8;
